import { ValueOf } from '../utilities/types';

const auditTypes = {
  ACTIVATED: 'activated',
  ATTACH_ENTITY: 'attach-entity',
  CLIENT_SECRET_DISPLAYED: 'ClientSecretDisplayed',
  COMMENT_EDITED: 'comment-edited',
  COMMENT_DELETED: 'comment-deleted',
  COMMENT: 'comment',
  CONNECT: 'connect',
  CREATE: 'create',
  DEACTIVATED: 'deactivated',
  DELETE: 'delete',
  DELETE_TRANSACTION_SNAPSHOT: 'delete-transaction-snapshot',
  DISCONNECT: 'disconnect',
  DETACH_ENTITY: 'detach-entity',
  GENERATE: 'generate',
  GENERATE_FORM_LINK: 'generate-form-link',
  LOGIN: 'login',
  LOGOUT: 'logout',
  MERGED: 'merged',
  REASSIGN_TRANSACTION_TYPES: 'reassign-transaction-types',
  RECOMMENDATION: 'recommendation',
  REPROCESSED: 'reprocessed',
  RULE_CHECK: 'ruleCheck',
  SAVE_TRANSACTION_SNAPSHOT: 'save-transaction-snapshot',
  START_ANALYSIS: 'start-analysis',
  STATUS: 'status',
  SCORE_UPDATED: 'score-updated',
  UPDATE: 'update',
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',
  ESCALATE: 'escalate',
  DEESCALATE: 'deescalate',
} as const;

export type AuditTypes = ValueOf<typeof auditTypes>;

export default auditTypes;
